import { NmeaConfig } from "./NmeaConfig"

export class HomeImagesConfig {
            
    public images:Array<string>

    constructor({images=["/img/home-slide-bridges02-nb.0b5f66ed.jpg"]} = {}) {                
        this.images = images
    }    

    static createHomeImagesConfig(datas:string) {               
        const config = (datas && datas.length > 0)? new HomeImagesConfig(JSON.parse(datas)): new HomeImagesConfig()                        
        return config
    }

}
